import { render, staticRenderFns } from "./bikeRepair.vue?vue&type=template&id=12a4fbae&"
import script from "./bikeRepair.vue?vue&type=script&lang=js&"
export * from "./bikeRepair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports